import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, err: null };
  }

  static getDerivedStateFromError(err) {
    return { hasError: true, err };
  }

  componentDidCatch(err, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", err, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-navy-900 text-white grain flex items-center justify-center p-6" data-testid="error-boundary">
          <div className="max-w-md text-center">
            <div className="text-[11px] tracking-[0.35em] uppercase text-peach-300 font-bold">Something broke</div>
            <h1 className="mt-3 font-heading font-bold text-3xl">Désolé — une erreur est survenue.</h1>
            <p className="mt-3 text-sm text-[#cdc1ed]">A small glitch. You can try reloading the page.</p>
            <button
              onClick={() => window.location.reload()}
              data-testid="error-reload-btn"
              className="mt-6 px-6 py-3 rounded-full bg-peach-500 text-navy-900 font-semibold hover:bg-peach-400 transition"
            >
              Reload
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
